import { useQuery } from "@tanstack/react-query";
import type { DateRange } from "@/hooks/useDateRange";
import { analyticsRevenueService } from "@/services/analytics-revenue-service";
import { useAnalyticsOverviewRange } from "./useAnalyticsOverviewRange";

export const analyticsRevenueKeys = {
  all: ["analytics-revenue"] as const,
  total: (hotelId: string, from: string, to: string) =>
    [...analyticsRevenueKeys.all, "total", hotelId, from, to] as const,
};

export function useRevenueTotal(dateRange: DateRange) {
  const { hotelId, from, to, isReady } = useAnalyticsOverviewRange(dateRange);

  return useQuery({
    queryKey: analyticsRevenueKeys.total(hotelId, from, to),
    queryFn: () => analyticsRevenueService.getTotal({ hotelId, from, to }),
    enabled: isReady,
  });
}
